/**
 * LiveStreamsBridge — render-null mount point for the push WS streams.
 *
 * Mounted once inside the authenticated AppShell so every page benefits:
 * the hooks connect /ws/signals, /ws/prices and /ws/trades and invalidate
 * the matching TanStack Query caches on each push, keeping REST-backed
 * views fresh without polling. A dead or unauthorized socket is non-fatal:
 * the hooks cap reconnects (exponential backoff, 10 attempts) and then go
 * quiet, leaving normal REST fetching untouched.
 */

import {
  usePriceStream,
  useSignalStream,
  useTradeStream,
} from "@/hooks/use-websocket";

export function LiveStreamsBridge() {
  // Default enabled — the shell only renders for authenticated sessions.
  useSignalStream();
  usePriceStream();
  useTradeStream();
  return null;
}
